import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _5mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"5mp"}/>
}
